module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v(_vm._s(_vm.msg))]), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "section section--match"
  }, [_c('h2', [_vm._v("Match")]), _vm._v(" "), _c('Match', {
    on: {
      "matchUpdated": _vm.updateMatch
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "section section--teams"
  }, [_c('h2', [_vm._v("Teams")]), _vm._v(" "), _c('Team', {
    on: {
      "teamUpdated": _vm.updateTeams
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "section section--players"
  }, [_c('h2', [_vm._v("Players")]), _vm._v(" "), _c('Player', {
    on: {
      "playerUpdated": _vm.updatePlayers
    }
  })], 1)]), _vm._v(" "), _c('Meta', {
    attrs: {
      "match": _vm.config.match,
      "teams": _vm.config.teams,
      "players": _vm.config.players
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3dbb0000","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 28
// module chunks = 0